// import React, { Component } from 'react';
var React = require('react');
var ReactNative = require('react-native')

var ReUpField = require('./ReUpField');
var ReUpPicker = require('./ReUpPicker');
var {
  AppRegistry,
  Text,
  StyleSheet,
  View,
    TextInput
} = ReactNative;

// import Button from '@lightspeed/cirrus-button';
const DEFAULT_PHONE_LOCALES = [{"Region":"CA","Code":"1"}];

var ReUpPhoneNumberInput = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      style: {},
      isInError: false,
      phoneLocales: DEFAULT_PHONE_LOCALES,
      phoneNumberChanged: ()=>{},
      countryChanged: ()=>{},
      okSelected: ()=>{},
      needsNewPredictedPhoneNumber: (phoneNumber)=>{}
    }
  },

  getInitialState : function()
  {
    var state = {};
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    state.isInError = false;
    state.currentPhoneNumber = "";
    state.currentCountryIndex = 0;
    state.partialPlaceHolderPhoneNumber = locManager.localizedStringForKey("PHONE_OPTION");
    state.phoneLocales = (this.props.phoneLocales == null || typeof this.props.phoneLocales === 'undefined' || this.props.phoneLocales.length <= 0) ? [{"Region":"CA","Code":"1"}] : this.props.phoneLocales;

    return state;
  },

  _hasSetPlaceholder : false,
  setPlaceHolderPhoneNumber : function(fullPhoneNumber)
  {
    if( fullPhoneNumber === null ) return;

    var currentCountryCode = this.getCountryCode();
    if( fullPhoneNumber.indexOf(currentCountryCode) === 0 )
    {
      this._hasSetPlaceholder = true;

      var partialPlaceHolderPhoneNumber = fullPhoneNumber.substring(currentCountryCode.length, fullPhoneNumber.length);
      this.setState({partialPlaceHolderPhoneNumber})
    }
    else if( !this._hasSetPlaceholder )
    {      
      for( var i = 0; i < this.state.phoneLocales.length; i++ )
      {
        var phoneLocale = this.state.phoneLocales[i];
        var fullPhoneNumberHasThisCountryCode = fullPhoneNumber.indexOf(phoneLocale.Code) === 0;
        if( fullPhoneNumberHasThisCountryCode )
        {
          this._hasSetPlaceholder = true;

          var partialPlaceHolderPhoneNumber = fullPhoneNumber.substring(phoneLocale.Code.length);
          this.countrySelected(i);
          this.setState({partialPlaceHolderPhoneNumber})
          break;
        }
      }
    }
  },

  componentWillReceiveProps : function(newProps)
  {
    var phoneLocales = (newProps.phoneLocales == null || typeof newProps.phoneLocales === 'undefined' || newProps.phoneLocales.length <= 0) ? [{"Region":"CA","Code":"1"}] : newProps.phoneLocales;
    this.setState({phoneLocales})
  },

  focus : function()
  {
    // this._field.focus();
  },

  getCountryCode : function()
  {
    return this.state.phoneLocales[this._picker.state.valueIndex].Code;
  },

  setPhoneNumber : function(currentPhoneNumber)
  {
    var currentPhoneNumber = currentPhoneNumber.substring(0, 20);
    // this._field.setText(currentPhoneNumber);
    this.setState({currentPhoneNumber});
    this.props.phoneNumberChanged(this.getCountryCode(), this.getCountryCode() + currentPhoneNumber);
  },

  setFullPhoneNumber : function(fullPhoneNumber)
  {
    var currentCountryCode = this.getCountryCode();
    var needsNewCountryCode = fullPhoneNumber.indexOf(currentCountryCode) !== 0;
    if( needsNewCountryCode )
    {
      for( var i = 0; i < this.state.phoneLocales.length; i++ )
      {
        var phoneLocale = this.state.phoneLocales[i];
        var fullPhoneNumberHasThisCountryCode = fullPhoneNumber.indexOf(phoneLocale.Code) === 0;
        if( fullPhoneNumberHasThisCountryCode )
        {
          var phoneNumber = fullPhoneNumber.substring(phoneLocale.Code.length, fullPhoneNumber.length - phoneLocale.Code.length + 1);
          this.countrySelected(i);
          this.setPhoneNumber(phoneNumber);
        }
      }
    }
    else
    {
      var phoneNumber = fullPhoneNumber.substring(currentCountryCode.length, fullPhoneNumber.length - currentCountryCode.length + 1);
      this.setPhoneNumber(phoneNumber);
    }
  },

  setPredictedPhoneNumber : function(predictedPhoneNumber)
  {
    this.setState({predictedPhoneNumber})
  },

  getPhoneNumber : function()
  {
    return this.getCountryCode() + this.state.currentPhoneNumber;
  },

  deleteSelected : function()
  {
    this.setPhoneNumber(this.state.currentPhoneNumber.substring(0, Math.max(0, this.state.currentPhoneNumber.length-1)));
  },

  numSelected : function(num)
  {
    var newPhoneRaw = this.state.currentPhoneNumber + "" + num;
    this.setPhoneNumber(newPhoneRaw);
  },

  clearSelected : function()
  {
    this.countrySelected(0);
    // this.
  },

  countrySelected : function(index)
  {
    this.setState({currentCountryIndex:index});
    this._picker.setValue(index);
    this.props.countryChanged(this.state.phoneLocales[index]);
    this.props.phoneNumberChanged(this.state.phoneLocales[index], this.state.phoneLocales[index].Code + this.state.currentPhoneNumber);
  },

  render : function() 
  {
    var self = this;

    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var values = [];
    var errorStyle = this.props.isInError?{borderColor:(appManager.getErrorColor())}:{borderColor:'#abb3b3'};
    for( var i = 0; i < this.state.phoneLocales.length; i++ ) values.push("+" + this.state.phoneLocales[i].Code);

    return (
      <View style={this.props.style}>
        <View style={{flex:-1, flexDirection:'row',justifyContent:'space-around', fontSize:20}}>
          <View style={{flex:1, paddingTop:4, paddingRight:4, paddingBottom:4}}>
            <ReUpPicker ref={(a) => { this._picker=a }} style={[{borderRadius: 3,backgroundColor: "white", borderColor: '#abb3b3', borderWidth: 1 , borderStyle: 'solid'},errorStyle]} appManager={appManager} values={values}  onValueChange={(value)=>{self.countrySelected(value)}}/>
          </View>
          <View style={{flex:4, paddingTop:4, paddingLeft:4, paddingBottom:4}}>
            <TextInput ref={(a) => { this._field=a }} style={[{borderRadius: 3, margin: 0, backgroundColor: 'white', padding: 15, fontSize:20, borderWidth: 1 , borderStyle: 'solid'},errorStyle]} keyboardType={'phone-pad'} autoCompleteType={'tel'} textContentType={'telephoneNumber'} appManager={appManager} invertBG={true} hideLine={true} value={this.state.currentPhoneNumber} placeholder={this.state.partialPlaceHolderPhoneNumber} onChangeText={(phoneNumber)=>{self.setPhoneNumber(phoneNumber.replace())}}/>
          </View>
        </View>
      </View>
    );
  }
});

module.exports = ReUpPhoneNumberInput;

